<template>
    <b-col id="new-solution-images" :class="computedBackground" style="margin-top: 10px; padding-bottom: 0px">
        <b-row id="multiple_image_container" v-show="layout.pics === 4">
            <b-col :key="index" align="center" class="pmis-image justify-content" v-bind="img.sizes"
                   v-for="(img, index) in images">
                <!--                <img :src="img.src" class="img-fluid"/>-->

                <div class="pmis-img-element">
                    <!-- name attribute is like an ID -->
                    <vue-image-chooser :id="'image-chooser-'+index" :name="img.src" @change="uploadFile"
                                       :progress="progress" :error="error"/>
                </div>

            </b-col>
        </b-row>
        <b-row id="single_image_container" style="display: none;" v-show="layout.pics === 1">
            <b-col lg="12" class="pmis-image" align="center">
                <div class="pmis-large-img-element">
                    <!-- name attribute is like an ID -->
                    <vue-image-chooser id="image-chooser-5" name="single-src" @change="uploadFile" error=""/>
                </div>

            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import {pmisColorsMixin} from "../../../mixins/pmis-colors-mixin";

    export default {
        name: "PmisFormPresentationImageContainer",
        data() {
            return {
                progress: null,
                error: null,
            }
        },
        props: {
            name: String,
            images: Array,
            layout: Object
        },
        methods: {
            uploadFile(file) {
                // console.log(file);
                // this.progress = 0;
                let formData = new FormData();
                formData.append('image', file);
                // var config = {
                //     onUploadProgress: progressEvent => {
                //         var percentCompleted = Math.round(
                //             (progressEvent.loaded * 100) / progressEvent.total
                //         )
                //         this.progress = percentCompleted
                //     }
                // }
                // try {
                //     const { data } = await axios.post(
                //         '/api/route/to/upload/image',
                //         formData,
                //         config
                //     )
                // } catch (e) {
                //     this.error = 'Error has occured'
                // }
            }
        },
        mixins: [pmisColorsMixin]
    }
</script>

<style lang="scss" scoped>

    .image-uploader {
        height: 230px !important;
    }

    #image-chooser-5{
        height: 460px !important;
    }

    .pmis-image {
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
        /*padding-top: 20px;*/
    }

    .pmis-img-element {
        width: 230px;
        height: 230px;
    }

    .pmis-large-img-element {
        width: 460px;
        height: 460px !important;
    }
</style>
